"use client";
import React, { useEffect, useMemo, useState } from "react";
// import GooglePlay from "../assets/icons/googleplay";
// import { ButtonSize, ButtonVariant, RegularButton } from "@/stories/button/button";
// import Apple from "@/app/assets/icons/apple";
import Image from "next/image";
import Facebook from "../assets/icons/facebook";
import Instagram from "../assets/icons/instagram";
import LinkedIn from "../assets/icons/linkedin";
import X from "../assets/icons/x";
import Youtube from "../assets/icons/youtube";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/stories/accordian/accordian";
import {
    FACEBOOK,
    ICM_NAME_FULL,
    INSTAGRAM,
    LINKEDIN,
    X_TWITTER,
    YOUTUBE,
} from "@/app/utils/constants";
import { DirectPaths } from "@/config/routes";
import { setAnalyticsEvent } from "@/app/utils/SetAnalyticsEvent";
import useMobile from "../hooks/use-mobile";
import { usePathname } from "next/navigation";
import { isUnlistedShareProductPath } from "@/app/unlisted-shares/[...id]/slug";
import { useAuth } from "@/context/authcontext";
// import { ProductType } from "@/types/product";
import { InvestmentOptions } from "@/app/interface/platform";
import useNavItems from "@/app/hooks/nav-items.hook";
import { getActiveNavLogoUrl } from "@/app/utils/get-nav-logo-url";
// import { isClient as isClientSide } from "@/lib/utils";

interface FooterProps {
    active?: string;
    isClient?: boolean;
}

export const Footer: React.FC<FooterProps> = ({ active = InvestmentOptions.Home, isClient = false }) => {
    const pathName = usePathname();
    const { isAuthenticated } = useAuth();
    const navItems = useNavItems({ active, isLoggedIn: Boolean(isAuthenticated) });

    const [isInvestNowSection, setIsInvestNowSection] = useState(false);
    const [accordianValue, setAccordianValue] = useState<string>(!isClient ? "Disclaimer" : "");

    useEffect(() => {
        setAccordianValue("");
    }, []);

    const productLinks = [
        {
            url:
                `${isAuthenticated ? process.env.ICM_BULLION_POST_URL : process.env.ICM_BULLION_URL}${DirectPaths.BULLION_POSTFIX_PATH + DirectPaths.GOLD}` ||
                "#",
            heading: process.env.SHOW_BULLION === "true" ? "Gold" : "",
            events: "Gold_Footer",
        },
    ];

    const socialLinks = [
        { url: FACEBOOK, heading: <Facebook className="text-white" /> },
        { url: INSTAGRAM, heading: <Instagram className="text-white" /> },
        { url: LINKEDIN, heading: <LinkedIn className="text-white" /> },
        { url: X_TWITTER, heading: <X className="text-white" /> },
        { url: YOUTUBE, heading: <Youtube className="text-white" /> },
    ];

    const ICMMediaLinks = [
        { url: process.env.ICM_ABOUT || "#", heading: "About us" },
        // { url: process.env.ICM_MEDIA || "#", heading: "Media", target: "_blank" },
        // { url: process.env.ICM_CAREERS || "#", heading: "Career" },
        /* {
            url: `${process.env.ICM_URL}${DirectPaths.ANNOUNCEMENT}` || "#",
            heading: "Important Announcement",
        }, */
        { url: `${process.env.ICM_URL}/refer`, heading: "Refer", events: "Refer_Footer" },
        { url: `${process.env.ICU_LEARN}` || "#", heading: "Blogs", target: "_blank" },

    ];

    const ICMQuickLinks = [
        {
            url: `${process.env.ICM_URL}${DirectPaths.TERMS_AND_CONDITIONS}` || "#",
            heading: "Terms & Conditions",
        },
        {
            url: `${process.env.ICM_URL}${DirectPaths.PRIVACY_POLICY}` || "#",
            heading: "Privacy Policy",
        },
        /* {
            url: `${process.env.ICM_URL}${DirectPaths.INVESTOR_RELATIONS}` || "#",
            heading: "Investor Relations",
        }, */
        { url: `${process.env.ICM_URL}${DirectPaths.CONTACT}` || "#", heading: "Contact Us" },
        {
            url:
                /** Disclaimer logic on Refer layout.tsx - show UE disclaimer on Refer */
                active === InvestmentOptions.UnlistedShares || active === InvestmentOptions.Refer
                    ? `${process.env.ICM_URL}${DirectPaths.UE_DISCLAIMER}` || "#"
                    : `${process.env.ICM_URL}${DirectPaths.DISCLAIMER}` || "#",
            heading: "Disclaimer",
        },
        {
            url: `${process.env.ICM_URL}${DirectPaths.POLICY_CENTER}` || "#",
            heading: "Legal & Regulatory",
        },
    ];

    const getWhiteLogo = (url: string) => {
        const original = url.substring(url.lastIndexOf("/"));
        const newUrl = url.replace(original, "/white" + original);
        return newUrl;
    };

    const logoUrl = useMemo(
        () =>
            getActiveNavLogoUrl(
                navItems,
                getWhiteLogo(String(process.env.ICM_LOGO_URL ?? "")),
                getWhiteLogo,
            ),
        [navItems],
    );

    interface FooterLink {
        url: string;
        heading: string | React.ReactNode;
        events?: string;
        target?: string;
    }

    const FooterLinkList = (section: FooterLink[]) => {
        return (
            <>
                {section.map((link, index) => {
                    if (link.heading === "") return;
                    return (
                        <a key={index} href={link.url} target={link.target ?? ""} className="flex">
                            <p
                                onClick={() => {
                                    setAnalyticsEvent(link.url, link.events || "");
                                }}
                            >
                                {link.heading}
                            </p>
                        </a>
                    );
                })}
            </>
        );
    };

    const { isMobile } = useMobile(); // ✅ Call the hook here

    useEffect(() => {
        if (
            isMobile &&
            (pathName.includes("/unlisted-shares") ||
                pathName.includes("/refer") ||
                (process.env.SHOW_BULLION === "true" && pathName.includes("/bullion")) ||
                isUnlistedShareProductPath(pathName))
        ) {
            setIsInvestNowSection(true);
        } else {
            setIsInvestNowSection(false);
        }
    }, [isMobile, pathName]);

    return (
        <footer
            className={
                "mx-auto bg-neutral-900 px-5 py-10 md:px-[140px] md:py-[100px] " +
                (isInvestNowSection ? " pb-16" : "")
            }
        >
            {" "}
            <div className="md:container">
                <div className="mb-14 flex flex-col justify-between md:flex-row">
                    <div className="mb-6 flex flex-col gap-6 md:mb-0 md:w-[270px] md:gap-10">
                        <Image src={logoUrl} alt="InCred Logo" width={100} height={41} />

                        <p className="text-base font-medium text-neutral-300">
                            What you do with your money today can change how you live tomorrow.
                            That’s the power of investing right. We have built {ICM_NAME_FULL} to
                            give everyone a chance to do that.
                        </p>

                        <div className="flex items-center justify-start gap-6">
                            {FooterLinkList(socialLinks)}
                        </div>

                        {process.env.SHOW_BULLION === "true" &&
                        (active === InvestmentOptions.Gold ||
                            active === InvestmentOptions.Bullion) ? (
                            <div className="sec-bullion mb-6 mt-2 flex items-center justify-start gap-2 md:-mb-4 md:mt-4 md:min-w-[120%]">
                                <Image
                                    src={
                                        process.env.ICM_PUBLIC_ASSETS_URL +
                                        "images/v2/webp/MMTC-PAMP-Logo.webp"
                                    }
                                    alt=""
                                    width={50}
                                    height={50}
                                />
                                <span className="text-sm text-neutral-300">
                                    Digital Gold/Silver on {ICM_NAME_FULL} powered by MMTC-PAMP
                                </span>
                            </div>
                        ) : null}
                    </div>

                    <div className="flex flex-row flex-wrap gap-10 text-neutral-300 md:gap-[100px]">
                        <div>
                            <h5 className="mb-[18px] text-sm font-semibold text-white md:mb-[50px] md:text-lg">
                                {ICM_NAME_FULL}
                            </h5>
                            <div className="flex flex-col gap-s7 text-xs md:gap-s9 md:text-base">
                                {FooterLinkList(ICMMediaLinks)}
                            </div>
                        </div>

                        {process.env.SHOW_BULLION === "true" && (
                            <div className="flex-1">
                                <h5 className="mb-[18px] text-sm font-semibold text-white md:mb-[50px] md:text-lg">
                                    Products
                                </h5>
                                <div className="flex flex-col gap-s7 text-xs md:gap-s9 md:text-base">
                                    {FooterLinkList(productLinks)}
                                </div>
                            </div>
                        )}

                        <div>
                            <h5 className="mb-[18px] text-sm font-semibold text-white md:mb-[50px] md:text-lg">
                                Quick Link
                            </h5>
                            <div className="flex flex-col gap-s7 text-xs md:gap-s9 md:text-base">
                                {FooterLinkList(ICMQuickLinks)}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col justify-between gap-6 border-b-2 border-t-2 border-neutralOpacityLight-10 py-6 md:flex-row md:items-center md:gap-0">
                    <p className="text-base font-medium text-neutral-300">
                        &copy; 2026-2027 {ICM_NAME_FULL}, All rights reserved. Built with love in
                        India.
                    </p>
                    <div className="flex gap-4">
                        {/* <RegularButton
                            icon={<Apple className="text-white hover:text-black" />}
                            showRightIcon={false}
                            size={ButtonSize.Medium}
                            variant={ButtonVariant.SecondaryDefault}
                            className="w-full max-w-full border-neutralOpacityLight-30 text-white hover:text-black md:max-w-fit"
                            onClick={() => window.open(process.env.ICM_APPLE_APP_URL)}
                            label="iOS"
                        />
                        <RegularButton
                            showRightIcon={false}
                            icon={<GooglePlay className="text-white hover:text-black" />}
                            size={ButtonSize.Medium}
                            variant={ButtonVariant.SecondaryDefault}
                            onClick={() => window.open(process.env.ICM_PLAYSTORE_URL)}
                            className="w-full max-w-full border-neutralOpacityLight-30 text-white hover:text-black md:max-w-fit"
                            label="Android"
                        /> */}
                    </div>
                </div>

                <Accordion type="single" collapsible={true} value={accordianValue}
        onValueChange={setAccordianValue} className="w-full max-w-full">
                    <AccordionItem value={"Disclaimer"}>
                        <AccordionTrigger
                            showIcon={true}
                            className="text-left text-sm font-semibold leading-[32px] text-white md:text-xl"
                        >
                            Disclaimer
                        </AccordionTrigger>
                        <AccordionContent className="text-lg font-medium text-neutral-400">
                            {(active === InvestmentOptions.UnlistedShares ||
                                active === InvestmentOptions.Refer) && (
                                <div>
                                    <p className="text-sm font-medium leading-[19.6px]">
                                        The information and data provided on the {ICM_NAME_FULL}{" "}
                                        platform concerning unlisted equities are solely for
                                        informational purposes and should not be interpreted as a
                                        recommendation or solicitation to invest. {ICM_NAME_FULL}{" "}
                                        and its representatives are not SEBI-registered research
                                        analysts or advisors. Any research, analysis, or information
                                        presented on this platform does not constitute investment
                                        advice or a recommendation by {ICM_NAME_FULL} or its
                                        affiliates. Investors are strongly encouraged to perform
                                        their own thorough research and due diligence before making
                                        any investment decisions. Any decision to invest or not to
                                        invest shall be at your own discretion. Unlisted equities
                                        carry a higher risk profile compared to listed securities,
                                        including but not limited to liquidity risk, regulatory
                                        risk, and market volatility. Potential investors should be
                                        aware of these risks and consider them carefully. It is
                                        highly recommended that investors consult with their own
                                        financial advisors to understand the suitability of such
                                        investments in the context of their personal financial
                                        situation, investment objectives, and risk tolerance.
                                        Additionally, investors should read and fully understand the
                                        detailed risk profile and disclosures attached to the
                                        unlisted equities before proceeding with any investment.{" "}
                                    </p>
                                    <br />
                                    <p className="text-sm font-medium leading-[19.6px]">
                                        The information mentioned on the platform is based on
                                        publicly available data and to the best of our knowledge,
                                        does not constitute insider information.{" "}
                                    </p>
                                    <br />
                                    <p className="text-sm font-medium leading-[19.6px]">
                                        Pre-IPO shares are unlisted securities, but this should not
                                        be interpreted as {ICM_NAME_FULL} guaranteeing or confirming
                                        that an IPO will take place for these shares. The decision
                                        to proceed with an IPO is entirely at the discretion of the
                                        issuing company, which may choose not to go public.{" "}
                                    </p>
                                    <br />
                                    <p className="text-sm font-medium leading-[19.6px]">
                                        Unlisted shares are subject to a lock-in period of six
                                        months from the date of listing.{" "}
                                    </p>
                                    <br />
                                    <p className="text-sm font-medium leading-[19.6px]">
                                        {ICM_NAME_FULL} is the brand name of ETA Fintech Private
                                        Limited with its registered office at The Capital, Unit No
                                        1203, 12th floor, B Wing, Plot No. C-70, G Block, Bandra
                                        Kurla Complex, Mumbai – 400 051.
                                        <br /> Unless otherwise mentioned, ETA Fintech Private
                                        Limited will be the counterparty (seller) while making your
                                        investment.{" "}
                                    </p>
                                </div>
                            )}
                            {active === InvestmentOptions.Home /* || active === "Calculator" */ ? (
                                <div>
                                    <p className="text-sm font-medium leading-[19.6px]">
                                        The information and data provided on the {ICM_NAME_FULL}{" "}
                                        platform concerning unlisted equities are solely for
                                        informational purposes and should not be interpreted as a
                                        recommendation or solicitation to invest. {ICM_NAME_FULL}{" "}
                                        and its representatives are not SEBI-registered research
                                        analysts or advisors. Any research, analysis, or information
                                        presented on this platform does not constitute investment
                                        advice or a recommendation by {ICM_NAME_FULL} or its
                                        affiliates. Investors are strongly encouraged to perform
                                        their own thorough research and due diligence before making
                                        any investment decisions. Any decision to invest or not to
                                        invest shall be at your own discretion. Unlisted equities
                                        carry a higher risk profile compared to listed securities,
                                        including but not limited to liquidity risk, regulatory
                                        risk, and market volatility. Potential investors should be
                                        aware of these risks and consider them carefully. It is
                                        highly recommended that investors consult with their own
                                        financial advisors to understand the suitability of such
                                        investments in the context of their personal financial
                                        situation, investment objectives, and risk tolerance.
                                        Additionally, investors should read and fully understand the
                                        detailed risk profile and disclosures attached to the
                                        unlisted equities before proceeding with any investment.
                                    </p>
                                    <br />
                                    <p className="text-sm font-medium leading-[19.6px]">
                                        The information mentioned on the platform is based on
                                        publicly available data and to the best of our knowledge,
                                        does not constitute insider information.{" "}
                                    </p>
                                    <br />
                                    <p className="text-sm font-medium leading-[19.6px]">
                                        Pre-IPO shares are unlisted securities, but this should not
                                        be interpreted as {ICM_NAME_FULL} guaranteeing or confirming
                                        that an IPO will take place for these shares. The decision
                                        to proceed with an IPO is entirely at the discretion of the
                                        issuing company, which may choose not to go public.{" "}
                                    </p>
                                    <br />
                                    <p className="text-sm font-medium leading-[19.6px]">
                                        Unlisted shares are subject to a lock-in period of six
                                        months from the date of listing.{" "}
                                    </p>
                                    <br />
                                    <p className="text-sm font-medium leading-[19.6px]">
                                        {ICM_NAME_FULL} is the brand name of ETA Fintech Private
                                        Limited with its registered office at The Capital, Unit No
                                        1203, 12th floor, B Wing, Plot No. C-70, G Block, Bandra
                                        Kurla Complex, Mumbai – 400 051. Unless otherwise mentioned,
                                        ETA Fintech Private Limited will be the counterparty
                                        (seller) while making your investment.{" "}
                                    </p>
                                    <br />
                                </div>
                            ) : (
                                <></>
                            )}
                            {process.env.SHOW_BULLION === "true" &&
                                (active === InvestmentOptions.Bullion ||
                                    active === InvestmentOptions.Gold) && (
                                    <div>
                                        <p className="text-sm font-medium leading-[19.6px]">
                                            ETA Fintech Private Limited, operating under the brand
                                            name &ldquo;{ICM_NAME_FULL},&rdquo; provides a digital
                                            platform that facilitates the purchase and sale of
                                            &ldquo;Digital Gold/Silver.&rdquo; The contractual
                                            relationship in relation to the Digital Gold/Silver is
                                            exclusively between the Client and MMTC-PAMP India
                                            Private Limited (&ldquo;MMTC&rdquo;).
                                            {ICM_NAME_FULL} acts strictly as a referral partner and
                                            technology facilitator, providing a platform to these
                                            transactions. The Client&lsquo;s use of the{" "}
                                            {ICM_NAME_FULL} platform for any Digital Gold/Silver
                                            transaction constitutes an express agreement and
                                            acknowledgement of this arrangement.
                                        </p>
                                        <br />
                                        <p className="text-sm font-medium leading-[19.6px]">
                                            By initiating any transaction for Digital Gold/Silver on
                                            the {ICM_NAME_FULL} platform, the Client hereby
                                            represents and warrants that they have read, understood,
                                            and unequivocally agree to be bound by the terms and
                                            conditions of service, as well as the disclaimers of
                                            representation and warranties, as stipulated under{" "}
                                            <a
                                                href={`${process.env.ICM_URL}${DirectPaths.TERMS_AND_CONDITIONS}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="underline"
                                            >
                                                {ICM_NAME_FULL} Terms of Use
                                            </a>
                                            . It is the Client&lsquo;s sole responsibility to review
                                            and comprehend the agreement it signs with MMTC prior to
                                            undertaking any transaction. The initiation of a
                                            transaction shall be deemed as the Client&lsquo;s
                                            conclusive acceptance of the said terms and disclaimers.
                                        </p>
                                        <br />
                                        <p className="text-sm font-medium leading-[19.6px]">
                                            The Client acknowledges and agrees that all aspects of
                                            the Digital Gold/Silver, including but not limited to
                                            its delivery, quality, quantity, purity, and custodial
                                            arrangements, are the exclusive responsibility and
                                            liability of MMTC. {ICM_NAME_FULL} shall not be held
                                            liable, at any point in time or under any circumstances,
                                            for the quality, delivery, or any other matter
                                            pertaining to the Digital Gold/Silver transacted between
                                            the Client and MMTC. {ICM_NAME_FULL} makes no
                                            representations or warranties, express or implied, with
                                            respect to the Digital Gold/Silver offered by MMTC.
                                        </p>
                                        <br />
                                        <p className="text-sm font-medium leading-[19.6px]">
                                            Any complaints or grievances related to the quality,
                                            delivery, or other aspects of the Digital Gold/Silver
                                            must be addressed directly with MMTC. {ICM_NAME_FULL}{" "}
                                            may, at its sole discretion, assist in facilitating
                                            communication between the Client and MMTC as a courtesy,
                                            but is under no obligation to do so. {ICM_NAME_FULL}{" "}
                                            assumes no liability or responsibility arising from such
                                            facilitation. Resolution of any disputes or grievances
                                            is exclusively between the Client and MMTC.
                                        </p>
                                        <br />
                                        <p className="text-sm font-medium leading-[19.6px]">
                                            {ICM_NAME_FULL} hereby discloses that it receives
                                            remuneration from MMTC for the facilitation of Digital
                                            Gold/Silver transactions conducted through its platform,
                                            pursuant to a pre-existing commercial arrangement
                                            between {ICM_NAME_FULL} and MMTC. Investment in digital
                                            gold & silver is at your own risk & discretion. Please
                                            read the terms, conditions and disclaimers on the{" "}
                                            {ICM_NAME_FULL} & MMTC-PAMP web platform prior to any
                                            purchase.
                                        </p>
                                        <br />
                                        <p className="text-sm font-medium leading-[19.6px]">
                                            Investment in digital gold & silver is at your own risk
                                            & discretion. Please read the terms, conditions and
                                            disclaimers on the {ICM_NAME_FULL} & MMTC-PAMP web
                                            platform prior to any purchase.
                                        </p>
                                    </div>
                                )}
                        </AccordionContent>
                    </AccordionItem>
                </Accordion>
            </div>
        </footer>
    );
};
